export default [
    {
        path: '/',
        name: 'Query',
        component: () => import(/* webpackChunkName: "login" */ '../../views/Home.vue')
    },
    {
        path: '/query',
        name: 'Query',
        component: () => import(/* webpackChunkName: "login" */ '../../views/Home.vue')
    },
]
